import React from 'react';
import { formLabelPropTypes } from './FormLabelPropTypes';
const FormLabel = ({
  children,
  classname
}) => /*#__PURE__*/React.createElement("label", {
  className: classname || ''
}, children);
export default FormLabel;